import { useState, useEffect, useCallback } from 'react';
import { leaveTypesService } from '../services/api/leaveTypes';
import { LeaveType } from '../types';

export const useLeaveTypes = (status?: 'ACTIVE' | 'INACTIVE') => {
  const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchLeaveTypes = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await leaveTypesService.getAll(status);
      setLeaveTypes(data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [status]);

  useEffect(() => {
    fetchLeaveTypes();
  }, [fetchLeaveTypes]);

  return {
    leaveTypes,
    loading,
    error,
    refetch: fetchLeaveTypes,
  };
};

export const useActiveLeaveTypes = () => {
  const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchLeaveTypes = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await leaveTypesService.getActive();
      setLeaveTypes(data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLeaveTypes();
  }, [fetchLeaveTypes]);

  return {
    leaveTypes,
    loading,
    error,
    refetch: fetchLeaveTypes,
  };
};
